import {useEffect,useRef,useState} from 'react'
import {useCrmIdentity} from './crmIdentity'
import {acquireCrmPermissionContext,withCrmPermissionContext,observeCrmResource,type CrmPermissionContext,type ResourceState} from './crmSync'

export function useCrmResource<T>(resource:string,read:(previous:T|undefined,context:CrmPermissionContext)=>Promise<T>,includeSynthetic=false,filters:unknown=null,readAllowed?:()=>boolean){
 const identity=useCrmIdentity()
 const key=JSON.stringify([identity.userId,identity.workspaceId,identity.role,[...identity.capabilities].sort(),resource,filters,includeSynthetic])
 const reader=useRef(read);reader.current=read
 const readGate=useRef(readAllowed);readGate.current=readAllowed
 const [result,setResult]=useState<{key:string;context?:CrmPermissionContext;state:ResourceState<T>}>(()=>({key,state:{data:undefined,error:'',pending:true}}))
 useEffect(()=>{
  const [userId,workspaceId,role,capabilities,resourceName]=JSON.parse(key) as [string,string,string,string[],string]
  const context=acquireCrmPermissionContext({userId,workspaceId,role,capabilities})
  const observerKey=JSON.stringify([key,context.generation])
  return observeCrmResource<T>(observerKey,previous=>withCrmPermissionContext(context,()=>reader.current(previous,context)),state=>setResult({key,context,state}),context,resourceName,()=>readGate.current?.()!==false)
 },[key])
 // Never expose a previous scope for even one render.
 const state=result.key===key&&(result.context?.active||result.state.denied)?result.state:{data:undefined,error:'',pending:true}
 return {...state,principalScope:JSON.stringify([identity.userId,identity.workspaceId]),permissionContext:result.context}
}
